import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { ScoreType, ScoreWeight } from '../../models';
import { ScoreTypeDataService, Auth } from '../../services';
import { NavLink } from 'react-router-dom';
import { ScoreTypeForm } from './ScoreTypeForm';
import { LoadingIndicator, PVAPage } from '../../components';
import { UserStore, FilterStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface ScoreTypeEditProps extends BaseRouteProps<EditProps> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
    Auth?: Auth;
}

interface ScoreTypeEditState extends EditState<ScoreType> {
    open: boolean;
}

@inject('UserStore', 'FilterStore', 'Auth') @observer
export class ScoreTypeEdit extends React.Component<ScoreTypeEditProps, ScoreTypeEditState> {
    private scoreTypeDataService = new ScoreTypeDataService(this.props.notificationService);

    constructor(props: ScoreTypeEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            open: false
        };

        this.save = this.save.bind(this);
    }

    @computed get isSuperAdmin() {
        return this.props.Auth!.userRoleIn([Roles.SuperAdmin]);
    }

    private delete() {
        if (this.state.originalEntity && confirm('Are you sure you want to delete this raw score?')) {
            this.scoreTypeDataService.delete(this.state.originalEntity).then(() => {
                if (this.state.originalEntity) {
                    this.props.history.push('/surveyversion/' + this.state.originalEntity.surveyVersionID + '/scoretypes');
                }
            });
        }
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    {this.isSuperAdmin && <li className="options-header">Survey Maintenance</li>}
                    {this.isSuperAdmin && <li className="options-entry" onClick={(e) => this.delete()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-delete" /> <span style={{color: 'red'}}> Delete Raw Score</span>
                        </div>
                        <div className="options-entry-desc">
                            This will soft delete the raw score from the system.
                        </div>
                    </li>}

                </ul>
        </div>);
    }

    public render() {
        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        const ActionsButton = this.ActionsButton();

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/scoretypes'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {ActionsButton}
                    </PVAPage.Header.Buttons>
                    <div className="title">Edit Raw Score</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <ScoreTypeForm defaultValues={this.state.originalEntity} submit={this.save} notificationService={this.props.notificationService} surveyVersionId={this.state.originalEntity.surveyVersionID} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.scoreTypeDataService.get(id).then((scoreType: ScoreType) => {
                if (scoreType.scoreWeights) {
                    scoreType.scoreWeights = scoreType.scoreWeights.filter((x: ScoreWeight) => {
                        return !x.isDeleted;
                    });
                }
                this.setState({ originalEntity: scoreType });
            });
        }
    }

    private save(values: any) {
        this.scoreTypeDataService.update(values).then((success) => {
            // this.props.history.push('/question');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreType/ScoreTypeEdit.tsx